// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c5f9fb25","453":"734e4afa","667":"1b6a1aa1","977":"2d9cdeec"}[chunkId] + ".chunk.js";
};